import React from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import { Home, Print } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";

const PanTransactionResponse = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const errorValue = params.get("error");
    const txnId = params.get("txnId");

    const [ackNo, setAckNo] = React.useState(null);
    const [amount, setAmount] = React.useState(null);
    const [severity, setSeverity] = React.useState("info");

    const goToPanSection = () => {
        history.push("/pancard");
    };

    const goToPrintVoucher = () => {}

    React.useEffect(() => {
        switch(params.get("status")){
            case "0": {
                setSeverity("error");
                break;
            }
            case "1": {
                setSeverity("success");
                break;
            }
            default: {
                setSeverity("info");
                break;
            }
        }
        if(params.get("ackNo") && params.get("ackNo") != "") {
            setAckNo(params.get("ackNo"));
        }
        if(params.get("amount") && params.get("amount") != "") {
            setAmount(params.get("amount"));
        }
    }, []);

    return(
        <div className={classes.root}>
            <div className="response-contents">
                <Alert
                    onClose={() => {}}
                    severity={severity}
                >
                    <div className="response-text">
                        <p>Reference id: <b>{txnId}</b></p>
                        {ackNo && <p>Acknowledgement No: <b>{ackNo}</b></p>}
                        {/* {amount && <p>Amount: <b>{amount}</b></p>} */}
                        {errorValue != null && errorValue != "null" && <p>{errorValue}</p>}
                        <br/>
                        <p>Please note your acknowledgement number for future reference. A copy of receipt voucher will also be delivered to your registered email.</p>
                    </div>
                </Alert>
                <div className="action-group">
                    <a onClick={goToPanSection}>
                        <Home/> <span>Home</span>
                    </a>
                    {/* <a onClick={goToPrintVoucher}>
                        <Print/> <span>Voucher</span>
                    </a> */}
                </div>
            </div>
        </div>
    );
};

export default PanTransactionResponse;

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        "& .response-contents": {
            padding: "25px 25px 5px",
            boxShadow: `0px 0px 5px 0px rgba(158,156,158,1)`,
            MozBoxShadow: `0px 0px 5px 0px rgba(158,156,158,1)`,
            WebkitBoxShadow: `0px 0px 5px 0px rgba(158,156,158,1)`,
            borderRadius: 5,
            "& .MuiAlert-root": {
                flexDirection: 'column'
            },
            "& .MuiAlert-icon": {
                justifyContent: "center"
            },
            "& .MuiSvgIcon-fontSizeInherit, .MuiSvgIcon-root": {
                fontSize: "4.5rem"
            },
            "& .MuiAlert-action": {
                display: "none"
            }
        },
        "& .response-text": {
            textAlign: "center",
            "& p": {
                fontFamily: theme.palette.font.primary,
                fontWeight: 500,
                fontSize: "1rem",
            },
            "& b": {
                fontWeight: 600
            }
        },
        "& .action-group": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 5,
            "& a": {
                cursor: "pointer",
                color: theme.palette.primary.main,
                display: "flex",
                alignItems: 'center',
                fontSize: "0.85rem",
                marginRight: 10,
                "& .MuiSvgIcon-root": {
                    fontSize: "1.1rem"
                },
                "&:hover": {
                    color: theme.palette.secondary.main
                }
            }
        }
    }
}));
